import React, {useContext} from 'react';
import "./Clouds.scss"
import Cloud1 from "../../../static/img/clouds/cloud1(left-top).png";
import Cloud2 from "../../../static/img/clouds/cloud2(right-top).png";
import Cloud3 from "../../../static/img/clouds/cloud3(right-bottom).png";
import Cloud4 from "../../../static/img/clouds/cloud4(right-bottom).png";
import Cloud5 from "../../../static/img/clouds/cloud5(left-bottom).png";
import Cloud6 from "../../../static/img/clouds/cloud6(left-bottom).png";

import { MapContext } from '../../../contexts/MapContext';

export default function Clouds(){

  const {zoom, defaultZoom} = useContext(MapContext);

  return (
    <>
      <div className={`clouds-wrapper ${zoom !== defaultZoom ? 'zoomed' : ''}`}>
        <img className='cloud1' src={Cloud1} alt="cloud" />
        <img className='cloud2' src={Cloud2} alt="cloud" />
        <img className='cloud3' src={Cloud3} alt="cloud" />
        <img className='cloud4' src={Cloud4} alt="cloud" />
        <img className='cloud5' src={Cloud5} alt="cloud" />
        <img className='cloud6' src={Cloud6} alt="cloud" />
      </div>
    </>
  );
};
